<template>
  <div
    class="modal modal-dialog-centered fade"
    :class="{show: isOpenModal}"
    :style="{display: isOpenModal ? 'block' : 'none'}"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0">
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click.prevent="closedModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot>
            <div
              v-if="message"
              class="modal-title font-open-sans font-semibold color_8d97ad font-20 text-center"
            >
              {{ message }}
            </div>
            <ul>
              <li
                v-for="(error, index) of errors"
                :key="index"
              >
                {{ error }}
              </li>
            </ul>
          </slot>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="green-btn font-bold my-2 py-2.5 px-4"
            @click.prevent="closedModal"
          >
            Зрозуміло
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    isOpenModal: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: null,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    closedModal() {
      this.$emit('closed')
    },
    submitModal() {
      this.$emit('submitModal')
    },
  },
}
</script>

<style scoped></style>
